<!-- 班级状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="status" type="classStatus" width="222px" />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-班级状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '班级状态：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const status = useQuery('classStatus', props.value);

    return {
      status,
    };
  },
};
</script>
